import React from "react";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

const ToggleSwitch = styled(Switch)(({ theme }) => ({
  width: 40,
  height: 20,
  padding: 0,
  marginRight: 10,
  "& .MuiSwitch-switchBase": {
    padding: 4,
    "&.Mui-checked": {
      transform: "translateX(20px)",
      color: theme.palette.common.white,
      "& + .MuiSwitch-track": {
        backgroundColor: "#3246D3",
        opacity: 1,
        border: "none",
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#3246D3",
      border: "6px solid #fff",
    },
  },
  "& .MuiSwitch-thumb": {
    width: 12,
    height: 12,
    boxShadow: "none",
  },
  "& .MuiSwitch-track": {
    borderRadius: 20,
    backgroundColor: "#B7C0C8",
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
}));

export function Toggle({ label, setValue, enabledValue, disabledValue }) {
  return (
    <div>
      <ToggleSwitch
        disableRipple
        onChange={(e) => setValue(e.target.checked ? enabledValue : disabledValue)}
      />
      {label && <span className="t--sm t--subtitle">{label}</span>}
    </div>
  );
}
